
import { Helmet } from "react-helmet-async";
import { Sarash, Nipun, karishma2, } from "../assets"
import { URLs } from "../lib/constants"
import { Link } from "react-router-dom"
import YouTubePopup from "./Youtube"
import React from 'react';
import { Star, Award, Users, TrendingUp, ArrowRight, CheckCircle, Phone, Mail, MapPin, Shield, Lock, AlertTriangle, Key, Smartphone, FileText, Scale, Layers, } from 'lucide-react';


// Mock data for team (replace with your actual data)
const ourTeam = [
  {
    id: 1,
    name: "CA Sarash Jain",
    position: "SENIOR PARTNER",
    image: Sarash
  },
  {
    id: 2,
    name: "CA Karishma Jain",
    position: "Partner",
    image: karishma2
  },
  {
    id: 3,
    name: "Mr Nipun Jain",
    position: "Advocate",
    image: Nipun
  }
];

// Ticks component for client industries
const Ticks = ({ children }) => (
  <div className="bg-white/20 backdrop-blur-sm border border-blue-300/30 rounded-lg p-3 hover:bg-white/30 transition-all duration-300">
    <div className="flex items-start gap-2">
      <CheckCircle className="w-5 h-5 text-green-400 mt-0.5 flex-shrink-0" />
      <span className="text-sm text-white leading-relaxed">{children}</span>
    </div>
  </div>
);

// Mock components for demonstration
const Hero = () => (
  <section className="relative min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white overflow-hidden" style={{ background: 'linear-gradient(135deg, #00688e 0%, #004a64 50%, #00688e 100%)' }}>
    {/* Background Image with Overlay */}
    <div
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80')`
      }}
    ></div>

    {/* Dark Overlay for better text readability */}
    <div className="absolute inset-0 bg-slate-900/80 backdrop-blur-[1px]"></div>

    {/* Gradient Overlay */}
    <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-800/70 to-slate-900/90"></div>

    {/* Content */}
    <div className="container mx-auto px-4 relative z-10 flex items-center min-h-screen">
      <div className="max-w-4xl mx-auto text-center">
        <h1 class="mt-0 md:mt-24 text-3xl sm:text-4xl pt-32  md:text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">
          Best CA Firm in India for Growth, Governance & Digital Excellence

        </h1>
        <p className="text-xl md:text-2xl text-slate-200 mb-8 leading-relaxed max-w-3xl mx-auto">
          Sarash Jain & Associates helps ambitious businesses move beyond compliance — empowering them with strategic financial advisory, AI-driven efficiency, and robust governance systems that drive long-term growth and trust.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-10">
          <span className="bg-slate-800/70 backdrop-blur-md border border-slate-700/50 px-6 py-3 rounded-full text-sm flex items-center gap-2 hover:bg-slate-700/70 transition-all duration-300">
            <Award className="w-4 h-4 text-yellow-400" />
            CFO-as-a-Service for start-ups & growth-stage firms
          </span>
          <span className="bg-slate-800/70 backdrop-blur-md border border-slate-700/50 px-6 py-3 rounded-full text-sm flex items-center gap-2 hover:bg-slate-700/70 transition-all duration-300">
            <Users className="w-4 h-4 text-blue-400" />
            AI-Powered Accounting & Reconciliation — up to 10x productivity



          </span>
          <span className="bg-slate-800/70 backdrop-blur-md border border-slate-700/50 px-6 py-3 rounded-full text-sm flex items-center gap-2 hover:bg-slate-700/70 transition-all duration-300">
            <Star className="w-4 h-4 text-green-400" />
            DPDPA-Compliant Secure Client Portal for total data protection

          </span>
        </div>
        <Link
          to={URLs.QUERIES}
          className="backdrop-blur-md border m-auto text-center align-middle border-white/20 hover:bg-white/20 text-white px-10 py-4 mb-4 rounded-xl text-lg font-semibold transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-3 mx-auto shadow-lg hover:shadow-2xl"
          style={{ backgroundColor: 'rgba(204, 241, 255, 0.1)' }}
        >
          Get Professional Consultation
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>

    {/* Scroll Indicator */}

  </section>
);

const Testimonials = () => (
  <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
    {[
      {
        name: "Rajesh Kumar",
        company: "TechStart Solutions",
        text: "Exceptional service and professional expertise. They helped us navigate complex regulatory requirements seamlessly."
      },
      {
        name: "Priya Sharma",
        company: "Manufacturing Corp",
        text: "The team's attention to detail and proactive approach has been invaluable for our business growth."
      },
      {
        name: "Amit Patel",
        company: "Global Ventures",
        text: "Outstanding audit services and strategic financial advice. Highly recommend for any business needs."
      }
    ].map((testimonial, index) => (
      <div key={index} className="bg-white p-6 rounded-xl shadow-lg border-2 border-blue-100">
        <div className="flex mb-4">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
          ))}
        </div>
        <p className="mb-4 italic" style={{ color: '#00688e' }}>"{testimonial.text}"</p>
        <div className="border-t pt-4" style={{ borderColor: '#ccf1ff' }}>
          <p className="font-semibold" style={{ color: '#00688e' }}>{testimonial.name}</p>
          <p className="text-sm text-blue-600">{testimonial.company}</p>
        </div>
      </div>
    ))}
  </div>
);

function Home() {
  return (

    <>
    <YouTubePopup />
      <Helmet>
        <meta charset="utf-8" />
        <title>Best CA Firm in India | Trusted by Businesses </title>
        <meta
          name="description"
          content="India’s best CA firm offering tax, audit & advisory services for startups and businesses. Trusted expertise for your financial success."
        />
        <meta
          name="keywords"
          content="best ca firm, best ca firm in india, top chartered accountant firm india, ca firm near me, taxation services india, gst services india, audit services india, business advisory india, chartered accountant services india"
        />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <link rel="canonical" href="https://sarashjain.com/" />

        {/* Open Graph */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Best CA Firm in India | Sarash Jain &amp; Associates" />
        <meta property="og:description" content="Looking for the best CA firm in India? Sarash Jain & Associates offers trusted audit, taxation, GST, and business advisory services to help you grow with confidence." />
        <meta property="og:url" content="https://sarashjain.com/" />
        <meta property="og:site_name" content="Sarash Jain &amp; Associates" />
        <meta property="og:updated_time" content="2025-08-14T00:00:00+00:00" />
        <meta property="og:image" content="https://sarashjain.com/static/media/new-logo.7e44a3ebe2d011ed301a.jpg" />
        <meta property="og:image:secure_url" content="https://sarashjain.com/static/media/new-logo.7e44a3ebe2d011ed301a.jpg" />
        <meta property="og:image:width" content="595" />
        <meta property="og:image:height" content="550" />
        <meta property="og:image:alt" content="Best CA Firm in India - Sarash Jain &amp; Associates" />
        <meta property="og:image:type" content="image/jpeg" />

        {/* Article Info */}
        <meta property="article:published_time" content="2025-08-14T00:00:00+00:00" />
        <meta property="article:modified_time" content="2025-08-14T00:00:00+00:00" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Best CA Firm in India | Sarash Jain &amp; Associates" />
        <meta name="twitter:description" content="Looking for the best CA firm in India? Sarash Jain & Associates offers trusted audit, taxation, GST, and business advisory services to help you grow with confidence." />
        <meta name="twitter:image" content="https://sarashjain.com/static/media/new-logo.7e44a3ebe2d011ed301a.jpg" />
        <meta name="twitter:label1" content="Written by" />
        <meta name="twitter:data1" content="Sarash Jain &amp; Associates" />
        <meta name="twitter:label2" content="Time to read" />
        <meta name="twitter:data2" content="4 minutes" />
      </Helmet>
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <Hero />

        {/* Company Introduction */}
        <section
          className="text-white py-20"
          style={{ backgroundColor: '#00688e' }}
        >
          <div className="container mx-auto px-4">
            <div>
              <h2 className="text-4xl font-bold mb-6 text-center md:text-left">
                Sarash Jain & Associates: Why We Are the Best CA Firm in India for Strategic Growth and Digital Governance
              </h2>
              <p className="text-xl text-blue-100 leading-relaxed text-left">
                Sarash Jain & Associates is built to meet the evolving needs of India’s high-value client segments.
                We go beyond transactional compliance to act as a strategic co-pilot for growth-oriented enterprises and complex organizations.
                Our mission is to directly address the core motivations behind clients’ search for the <b>best CA firm in India</b>, while eliminating systemic pain points that compromise trust and efficiency.
                The modern CA firm must combine elite advisory expertise with unparalleled governance standards.

              </p>
            </div>
          </div>
        </section>



        {/* Key Features */}
        <section
          className="py-24 relative overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #ffffff 0%, #e6f7ff 40%, #ccf1ff 100%)'
          }}
        >
          {/* Decorative gradient orbs */}
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-20 left-10 w-72 h-72 bg-[#b3e7ff] rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#99ddff] rounded-full blur-3xl"></div>
          </div>

          <div className="container mx-auto px-6 relative z-10">
            {/* Section Heading */}
            <div className="text-center mb-20">
              <h2 className="text-4xl font-medium mb-4 tracking-tight" style={{ color: '#00688e' }}>
                What Drives Clients to Choose Sarash Jain & Associates for Strategic Value and Accelerated Growth
              </h2>
              <div
                className="w-28 h-1.5 mx-auto rounded-full"
                style={{ backgroundColor: '#00688e' }}
              ></div>
            </div>

            <div className="max-w-5xl mx-auto text-center">
              {/* Subheading */}
              <h3 className="text-2xl font-semibold mb-4" style={{ color: '#00688e' }}>
                Understanding Client Motivations
              </h3>
              <p className="text-lg text-blue-800 mb-12 max-w-3xl mx-auto leading-relaxed">
                The search for the best CA firm in India is driven by a desire to:
              </p>

              {/* Motivations List */}
              <div className="grid md:grid-cols-3 gap-8 mb-16">
                {[
                  'Gain genuine strategic value',
                  'Achieve exponential operational efficiency',
                  'Move beyond simple compliance'
                ].map((text, index) => (
                  <div
                    key={index}
                    className="bg-white border-2 border-blue-100 rounded-2xl p-8 shadow-md hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500"
                  >
                    <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full shadow-lg"
                      style={{ backgroundColor: '#00688e' }}>
                      <span className="text-white text-2xl font-bold">
                        {index + 1}
                      </span>
                    </div>
                    <h4 className="text-xl font-semibold text-blue-700 leading-snug">{text}</h4>
                  </div>
                ))}
              </div>

              {/* Closing Statement */}
              <div
                className="bg-white border-2 border-blue-100 shadow-xl rounded-2xl p-10 max-w-3xl mx-auto transform hover:scale-[1.02] transition-all duration-500"
              >
                <p className="text-lg leading-relaxed text-blue-800 font-medium">
                  Sarash Jain & Associates aligns its service model with these top-tier client motivations —
                  ensuring every engagement translates into measurable business outcomes and long-term value creation.
                </p>
              </div>
            </div>
          </div>
        </section>


        {/* Why Choose Us */}
        <section
          className="py-20"
          style={{ backgroundColor: '#00668b' }}
        >
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold mb-6 text-white">
                Delivering Strategic Growth and Advisory Excellence
              </h2>
              <div
                className="w-24 h-1 mx-auto rounded-full"
                style={{ backgroundColor: '#c7ebf9' }}
              ></div>
            </div>

            <div className="max-w-6xl mx-auto space-y-12">
              {/* Maximizing Strategic Growth Section */}
              <div
                className="border-2 border-[#c7ebf9] rounded-xl p-8 transition-all duration-300 hover:shadow-lg hover:border-white"
                style={{ backgroundColor: '#c7ebf9' }}
              >
                <h3 className="text-3xl font-bold mb-6" style={{ color: '#00688e' }}>
                  Maximizing Strategic Growth and Delivering Advisory Premium
                </h3>
                <p className="leading-relaxed text-lg mb-8" style={{ color: '#00688e' }}>
                  At our firm, the definition of the best CA partner is synonymous with the ability to deliver an Advisory Premium — measurable, forward-looking results that go beyond compliance.
                </p>

                <h4 className="text-2xl font-semibold mb-4" style={{ color: '#00688e' }}>
                  Focus on Digital Transformation
                </h4>
                <ul className="space-y-3 mb-6 ml-6">
                  <li className="leading-relaxed text-lg flex items-start" style={{ color: '#00688e' }}>
                    <span className="mr-3 mt-1.5">•</span>
                    <span>We specialize in Digital Transformation & Technology Consulting, representing 51.63% of industry revenue.</span>
                  </li>
                  <li className="leading-relaxed text-lg flex items-start" style={{ color: '#00688e' }}>
                    <span className="mr-3 mt-1.5">•</span>
                    <span>This segment shows an impressive 8.41% CAGR, reflecting the growing demand for tech-driven financial services.</span>
                  </li>
                </ul>
              </div>

              {/* Strategic Co-Pilot Model Section */}
              <div
                className="border-2 border-[#c7ebf9] rounded-xl p-8 transition-all duration-300 hover:shadow-lg hover:border-white"
                style={{ backgroundColor: '#c7ebf9' }}
              >
                <h3 className="text-3xl font-bold mb-6" style={{ color: '#00688e' }}>
                  Strategic Co-Pilot Model for Growth-Oriented Clients
                </h3>
                <p className="leading-relaxed text-lg mb-6" style={{ color: '#00688e' }}>
                  We partner with start-ups and early-stage companies (7.12% CAGR) through:
                </p>
                <ul className="space-y-3 mb-6 ml-6">
                  <li className="leading-relaxed text-lg flex items-start" style={{ color: '#00688e' }}>
                    <span className="mr-3 mt-1.5">•</span>
                    <span>CFO-as-a-Service</span>
                  </li>
                  <li className="leading-relaxed text-lg flex items-start" style={{ color: '#00688e' }}>
                    <span className="mr-3 mt-1.5">•</span>
                    <span>Advanced tax structuring</span>
                  </li>
                  <li className="leading-relaxed text-lg flex items-start" style={{ color: '#00688e' }}>
                    <span className="mr-3 mt-1.5">•</span>
                    <span>Transaction advisory</span>
                  </li>
                </ul>
                <p className="leading-relaxed text-lg" style={{ color: '#00688e' }}>
                  Our role extends beyond reporting — we act as a strategic co-pilot, helping clients scale efficiently and sustainably.
                </p>
              </div>

              {/* Specialized Vertical Expertise Section */}
              <div
                className="border-2 border-[#c7ebf9] rounded-xl p-8 transition-all duration-300 hover:shadow-lg hover:border-white"
                style={{ backgroundColor: '#c7ebf9' }}
              >
                <h3 className="text-3xl font-bold mb-6" style={{ color: '#00688e' }}>
                  Specialized Vertical Expertise
                </h3>
                <p className="leading-relaxed text-lg mb-4" style={{ color: '#00688e' }}>
                  We focus on high-growth industries such as Healthcare & Life Sciences, expanding at 6.22% CAGR, driven by complex data and transparency needs.
                </p>
                <p className="leading-relaxed text-lg" style={{ color: '#00688e' }}>
                  This domain expertise positions us as the optimal strategic partner among any CA firm in India.
                </p>
              </div>
            </div>

            <div className="text-center mt-12">
              <Link
                to={URLs.ABOUT_US}
                className="text-[#00688e] px-10 py-4 rounded-xl text-lg font-semibold transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-3 shadow-lg hover:shadow-xl hover:opacity-90"
                style={{ backgroundColor: '#c7ebf9' }}
              >
                Experience the Difference
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </section>


        {/* About Us Summary */}
        <section
          className="text-white py-20"
          style={{
            background: 'linear-gradient(to bottom, white, #00668b)',
          }}
        >
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <h2 className="text-4xl font-bold mb-12" style={{ color: '#00688e' }}>
                Achieving Exponential Operational Efficiency Through AI
              </h2>

              {/* Leveraging AI Section */}
              <div className="rounded-xl p-8 mb-8" style={{ backgroundColor: '#00668b' }}>
                <h3 className="text-3xl font-bold mb-6 text-white">
                  Leveraging Artificial Intelligence for Productivity and Accuracy
                </h3>
                <p className="text-xl leading-relaxed text-white">
                  Modern businesses demand CA firms that harness AI-driven tools to enhance speed, accuracy, and decision-making.
                </p>
              </div>

              {/* 10x Productivity Gains Section */}
              <div className="rounded-xl p-8 mb-8" style={{ backgroundColor: '#00668b' }}>
                <h3 className="text-3xl font-bold mb-6 text-white">
                  10x Productivity Gains
                </h3>
                <p className="text-xl leading-relaxed mb-6 text-white">
                  We deploy AI reconciliation platforms that deliver up to tenfold productivity gains.
                </p>
                <p className="text-xl leading-relaxed text-white">
                  This ensures lower error rates, faster turnaround, and higher client satisfaction, while supporting our premium service positioning.
                </p>
              </div>

              {/* Real-Time Financial Insights Section */}
              <div className="rounded-xl p-8 mb-8" style={{ backgroundColor: '#00668b' }}>
                <h3 className="text-3xl font-bold mb-6 text-white">
                  Real-Time Financial Insights
                </h3>
                <p className="text-xl leading-relaxed mb-6 text-white">
                  Our proprietary technology suite provides real-time financial insights, enabling clients to eliminate outdated manual systems.
                </p>
                <p className="text-xl leading-relaxed text-white">
                  For MSMEs, this brings cost-effective automation, reliability, and standardized output quality.
                </p>
              </div>

              <Link
                to={URLs.ABOUT_US}
                className="linkStyles px-8 py-3 rounded-lg font-semibold transition-colors duration-300 inline-flex items-center gap-2"
                style={{ backgroundColor: '#ccf1ff', color: '#00688e' }}
                onMouseOver={(e) => (e.target.style.backgroundColor = '#b3e7ff')}
                onMouseOut={(e) => (e.target.style.backgroundColor = '#ccf1ff')}
                onClick={() => window.scrollTo(0, 0)}
              >
                Learn more about us
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </section>
        <section
          className="py-20 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #e6f7ff 0%, #ccf1ff 50%, #b3e7ff 100%)'
          }}
        >
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-20">
            <div
              className="absolute top-20 left-10 w-72 h-72 rounded-full blur-3xl"
              style={{ backgroundColor: '#00688e' }}
            ></div>
            <div
              className="absolute bottom-20 right-10 w-96 h-96 rounded-full blur-3xl"
              style={{ backgroundColor: '#00668b' }}
            ></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-6xl mx-auto">
              {/* Header */}
              <div className="text-center mb-20">
                <h2
                  className="text-5xl font-normal mb-6 leading-tight tracking-wide"
                  style={{ color: '#00688e' }}
                >
                  Mitigating Systemic Risk and Ensuring Governance Excellence
                </h2>
                <div
                  className="w-32 h-1.5 mx-auto rounded-full mb-6"
                  style={{ backgroundColor: '#00688e' }}
                ></div>
                <p
                  className="text-xl max-w-3xl mx-auto"
                  style={{ color: '#00668b' }}
                >
                  Setting the benchmark for regulatory compliance and structural maturity in India
                </p>
              </div>

              {/* Commitment to Governance Section */}
              <div
                className="rounded-3xl p-10 mb-10 transform transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl relative overflow-hidden border border-[#00688e]/30 bg-white/90 backdrop-blur-sm"
              >
                <div
                  className="absolute top-0 right-0 w-52 h-52 rounded-full -mr-24 -mt-24 transition-transform duration-500 group-hover:scale-150"
                  style={{ backgroundColor: '#ccf1ff', opacity: 0.3 }}
                ></div>
                <div className="relative z-10">
                  <div className="flex items-center gap-4 mb-6">
                    <div
                      className="w-16 h-16 rounded-xl flex items-center justify-center shadow-lg"
                      style={{ backgroundColor: '#00688e' }}
                    >
                      <CheckCircle className="w-8 h-8 text-white" />
                    </div>
                    <h3
                      className="text-3xl font-normal"
                      style={{ color: '#00688e' }}
                    >
                      Commitment to Governance and Structural Maturity
                    </h3>
                  </div>
                  <p className="text-xl leading-relaxed" style={{ color: '#00668b' }}>
                    As India's financial and regulatory landscape grows more complex, structural maturity has become essential for CA firms.
                  </p>
                </div>
              </div>

              {/* ICAI AQMM Level 4 Section */}
              <div
                className="rounded-3xl p-10 mb-10 transform transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl relative overflow-hidden border border-[#00688e]/30 bg-white/90 backdrop-blur-sm"
              >
                <div
                  className="absolute bottom-0 left-0 w-52 h-52 rounded-full -ml-24 -mb-24 transition-transform duration-500 group-hover:scale-150"
                  style={{ backgroundColor: '#ccf1ff', opacity: 0.3 }}
                ></div>
                <div className="relative z-10">
                  <div className="flex items-center gap-4 mb-6">
                    <div
                      className="w-16 h-16 rounded-xl flex items-center justify-center shadow-lg"
                      style={{ backgroundColor: '#00688e' }}
                    >
                      <Award className="w-8 h-8 text-white" />
                    </div>
                    <h3
                      className="text-3xl font-normal"
                      style={{ color: '#00688e' }}
                    >
                      ICAI AQMM Level  Commitment
                    </h3>
                  </div>
                  <div className="space-y-5">
                    <div
                      className="flex items-start gap-4 p-5 rounded-xl transition-all duration-300 hover:translate-x-2 hover:shadow-md"
                      style={{ backgroundColor: '#f0f9ff' }}
                    >
                      <div
                        className="w-3 h-3 rounded-full mt-2 flex-shrink-0"
                        style={{ backgroundColor: '#00688e' }}
                      ></div>
                      <p className="text-xl leading-relaxed" style={{ color: '#00668b' }}>
                        We follow the ICAI Audit Quality Maturity Model (AQMM), aiming for or maintaining Level  certification.
                      </p>
                    </div>
                    <div
                      className="flex items-start gap-4 p-5 rounded-xl transition-all duration-300 hover:translate-x-2 hover:shadow-md"
                      style={{ backgroundColor: '#f0f9ff' }}
                    >
                      <div
                        className="w-3 h-3 rounded-full mt-2 flex-shrink-0"
                        style={{ backgroundColor: '#00688e' }}
                      ></div>
                      <p className="text-xl leading-relaxed" style={{ color: '#00668b' }}>
                        This standard reflects excellence in Practice Management and Human Resource Management, reducing organizational risk and ensuring long-term reliability.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Expert Regulatory Compliance Section */}
              <div
                className="rounded-3xl p-10 transform transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl relative overflow-hidden border border-[#00688e]/30 bg-white/90 backdrop-blur-sm"
              >
                <div
                  className="absolute top-0 left-1/2 w-52 h-52 rounded-full -mt-24 transition-transform duration-500 group-hover:scale-150"
                  style={{ backgroundColor: '#ccf1ff', opacity: 0.3 }}
                ></div>
                <div className="relative z-10">
                  <div className="flex items-center gap-4 mb-6">
                    <div
                      className="w-16 h-16 rounded-xl flex items-center justify-center shadow-lg"
                      style={{ backgroundColor: '#00688e' }}
                    >
                      <Shield className="w-8 h-8 text-white" />
                    </div>
                    <h3
                      className="text-3xl font-normal"
                      style={{ color: '#00688e' }}
                    >
                      Expert Regulatory Compliance
                    </h3>
                  </div>
                  <p className="text-xl leading-relaxed mb-6" style={{ color: '#00668b' }}>
                    We provide comprehensive regulatory guidance, including:
                  </p>
                  <div className="grid md:grid-cols-2 gap-5 mb-6">
                    <div
                      className="flex items-center gap-3 p-5 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-md"
                      style={{ backgroundColor: '#f0f9ff' }}
                    >
                      <div
                        className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 shadow-md"
                        style={{ backgroundColor: '#00688e' }}
                      >
                        <CheckCircle className="w-6 h-6 text-white" />
                      </div>
                      <p className="text-lg font-medium" style={{ color: '#00668b' }}>
                        GST 2.0 reconciliation
                      </p>
                    </div>
                    <div
                      className="flex items-center gap-3 p-5 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-md"
                      style={{ backgroundColor: '#f0f9ff' }}
                    >
                      <div
                        className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 shadow-md"
                        style={{ backgroundColor: '#00688e' }}
                      >
                        <CheckCircle className="w-6 h-6 text-white" />
                      </div>
                      <p className="text-lg font-medium" style={{ color: '#00668b' }}>
                        Direct tax code compliance
                      </p>
                    </div>
                  </div>
                  <div
                    className="p-6 rounded-xl border-2 shadow-inner"
                    style={{ backgroundColor: '#f0f9ff', borderColor: '#00688e' }}
                  >
                    <p className="text-xl leading-relaxed font-medium" style={{ color: '#00668b' }}>
                      Our clients benefit from expert, up-to-date advice that ensures seamless adherence to evolving laws.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="py-16 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #003d52 0%, #00668b 50%, #00688e 100%)'
          }}
        >
          {/* Decorative elements */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-20 w-64 h-64 bg-white rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 left-20 w-80 h-80 bg-blue-300 rounded-full blur-3xl"></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-5xl mx-auto">
              {/* Header */}
              <div className="text-center mb-10">
                <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white leading-tight">
                  Eliminating Client Friction to Guarantee Trust, Security, and Quality
                </h2>
                <div className="w-24 h-1 mx-auto rounded-full" style={{ backgroundColor: '#ccf1ff' }}></div>
              </div>

              {/* Content Card */}
              <div
                className="rounded-2xl p-8 md:p-12 shadow-2xl transform hover:scale-105 transition-all duration-500 border-2 relative overflow-hidden group"
                style={{
                  backgroundColor: 'rgba(204, 241, 255, 0.95)',
                  borderColor: '#ccf1ff'
                }}
              >
                {/* Animated gradient overlay */}
                <div className="absolute top-0 right-0 w-32 h-32 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-700" style={{ backgroundColor: '#00688e', opacity: 0.1 }}></div>

                <div className="relative z-10">
                  <div className="flex items-start gap-5 mb-6">
                    <div className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg" style={{ backgroundColor: '#00688e' }}>
                      <Shield className="w-7 h-7 text-white" />
                    </div>
                    <div>
                      <h3 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#00688e' }}>
                        Transforming  Into Competitive Advantages
                      </h3>
                      <p className="text-lg md:text-xl leading-relaxed mb-4" style={{ color: '#00668b' }}>
                        The process of selecting the <b>best CA firm in India</b> often comes with concerns over data security, quality consistency, and pricing transparency.
                      </p>
                      <div className="flex items-start gap-3 p-4 rounded-xl border-l-4 shadow-md" style={{ backgroundColor: 'white', borderColor: '#00688e' }}>
                        <CheckCircle className="w-6 h-6 flex-shrink-0 mt-0.5" style={{ color: '#00688e' }} />
                        <p className="text-lg md:text-xl font-semibold leading-relaxed" style={{ color: '#00688e' }}>
                          At Sarash Jain & Associates, we address these concerns proactively, transforming friction into trust and assurance.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="py-20 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f4ff 50%, #ccf1ff 100%)'
          }}
        >
          {/* Decorative background elements */}
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-20 right-10 w-96 h-96 rounded-full blur-3xl" style={{ backgroundColor: '#00688e' }}></div>
            <div className="absolute bottom-10 left-10 w-80 h-80 rounded-full blur-3xl" style={{ backgroundColor: '#00668b' }}></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-6xl mx-auto">
              {/* Header */}
              <div className="text-center mb-16">
                <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" style={{ color: '#00688e' }}>
                  Ensuring Data Security and DPDPA Compliance
                </h2>
                <div className="w-32 h-1.5 mx-auto rounded-full" style={{ backgroundColor: '#00688e' }}></div>
              </div>

              {/* Main Content Card */}
              <div
                className="rounded-3xl p-10 md:p-12 shadow-2xl border-2 transform hover:shadow-3xl transition-all duration-500 relative overflow-hidden group"
                style={{
                  backgroundColor: 'white',
                  borderColor: '#00688e'
                }}
              >
                {/* Decorative corner element */}
                <div className="absolute top-0 right-0 w-40 h-40 rounded-full -mr-20 -mt-20 group-hover:scale-150 transition-transform duration-700" style={{ backgroundColor: '#ccf1ff', opacity: 0.4 }}></div>

                <div className="relative z-10">
                  {/* Subheading with icon */}
                  <div className="flex items-center gap-4 mb-8">
                    <div className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-xl" style={{ backgroundColor: '#00688e' }}>
                      <Lock className="w-8 h-8 text-white" />
                    </div>
                    <h3 className="text-3xl md:text-4xl font-bold" style={{ color: '#00688e' }}>
                      Mandatory Security and Compliance Framework
                    </h3>
                  </div>

                  {/* Pain Point Section */}
                  <div className="mb-8 p-6 rounded-2xl border-l-4 shadow-md" style={{ backgroundColor: '#fff5f5', borderColor: '#ef4444' }}>
                    <div className="flex items-start gap-3 mb-3">
                      <AlertTriangle className="w-6 h-6 flex-shrink-0 mt-1 text-red-500" />
                      <h4 className="text-2xl font-bold text-red-600">
                        Data Security Risks
                      </h4>
                    </div>
                    <p className="text-lg leading-relaxed ml-9" style={{ color: '#00668b' }}>
                      Client data — including PAN, GST returns, and bank statements — is highly sensitive. Traditional communication methods like email or WhatsApp expose companies to cyberattacks, which originate via email in over 90% of cases.
                    </p>
                  </div>

                  {/* Solutions Section */}
                  <div className="p-8 rounded-2xl border-2" style={{ backgroundColor: '#f0f9ff', borderColor: '#00688e' }}>
                    <div className="flex items-center gap-3 mb-6">
                      <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg" style={{ backgroundColor: '#00688e' }}>
                        <CheckCircle className="w-7 h-7 text-white" />
                      </div>
                      <h4 className="text-2xl md:text-3xl font-bold" style={{ color: '#00688e' }}>
                        Our Security Solutions
                      </h4>
                    </div>

                    {/* Secure Client Portal */}
                    <div className="mb-6">
                      <div className="flex items-start gap-3 p-5 rounded-xl shadow-md transform hover:translate-x-2 transition-all duration-300" style={{ backgroundColor: 'white' }}>
                        <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#00688e' }}>
                          <Shield className="w-6 h-6 text-white" />
                        </div>
                        <div>
                          <h5 className="text-xl font-bold mb-2" style={{ color: '#00688e' }}>
                            Secure Client Portal
                          </h5>
                          <p className="text-lg leading-relaxed" style={{ color: '#00668b' }}>
                            All document exchanges occur through a dedicated, encrypted platform.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Advanced Security Protocols */}
                    <div className="p-6 rounded-xl" style={{ backgroundColor: 'white' }}>
                      <div className="flex items-center gap-3 mb-5">
                        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#00688e' }}>
                          <Lock className="w-6 h-6 text-white" />
                        </div>
                        <h5 className="text-xl font-bold" style={{ color: '#00688e' }}>
                          Advanced Security Protocols
                        </h5>
                      </div>

                      <div className="grid md:grid-cols-2 gap-4">
                        {[
                          { icon: <Key className="w-5 h-5" />, text: "End-to-end encryption" },
                          { icon: <Smartphone className="w-5 h-5" />, text: "Two-Factor Authentication (2FA)" },
                          { icon: <Users className="w-5 h-5" />, text: "Role-based access control" },
                          { icon: <FileText className="w-5 h-5" />, text: "Complete audit trail for every document" }
                        ].map((item, index) => (
                          <div
                            key={index}
                            className="flex items-center gap-3 p-4 rounded-lg shadow-sm transform hover:scale-105 transition-all duration-300"
                            style={{ backgroundColor: '#f0f9ff' }}
                          >
                            <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#00688e', color: 'white' }}>
                              {item.icon}
                            </div>
                            <p className="text-base font-medium" style={{ color: '#00668b' }}>
                              {item.text}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Compliance Guarantee */}
                  <div className="mt-8 p-6 rounded-2xl border-2 shadow-lg" style={{ backgroundColor: '#e0f4ff', borderColor: '#00688e' }}>
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md" style={{ backgroundColor: '#00688e' }}>
                        <Award className="w-7 h-7 text-white" />
                      </div>
                      <p className="text-xl md:text-2xl font-bold leading-relaxed" style={{ color: '#00688e' }}>
                        These systems ensure compliance with the Digital Personal Data Protection Act (DPDPA) and guarantee client confidentiality.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="py-20 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #00384d 0%, #004c66 50%, #00688e 100%)',
          }}
        >
          {/* Decorative background elements */}
          <div className="absolute inset-0 opacity-30">
            <div
              className="absolute top-10 left-10 w-80 h-80 rounded-full blur-3xl"
              style={{ backgroundColor: '#0097b2' }}
            ></div>
            <div
              className="absolute bottom-20 right-20 w-96 h-96 rounded-full blur-3xl"
              style={{ backgroundColor: '#007b9e' }}
            ></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-6xl mx-auto">
              {/* Header */}
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold mb-6 leading-tight text-white">
                  Guaranteeing Structural Reliability and Quality Control
                </h2>
                <div
                  className="w-32 h-1.5 mx-auto rounded-full mb-4"
                  style={{ backgroundColor: '#00b8d9' }}
                ></div>
                <p className="text-xl font-semibold text-blue-100">
                  Building Trust Through Standardisation and Transparency
                </p>
              </div>

              {/* Main Content Card */}
              <div
                className="rounded-3xl p-10 md:p-12 shadow-2xl border-2 transform hover:shadow-3xl transition-all duration-500 relative overflow-hidden group"
                style={{
                  backgroundColor: '#002b3a',
                  borderColor: '#00b8d9',
                }}
              >
                {/* Decorative corner element */}
                <div
                  className="absolute bottom-0 left-0 w-40 h-40 rounded-full -ml-20 -mb-20 group-hover:scale-150 transition-transform duration-700"
                  style={{ backgroundColor: '#005e75', opacity: 0.4 }}
                ></div>

                <div className="relative z-10">
                  {/* Pain Point Section */}
                  <div
                    className="mb-10 p-6 rounded-2xl border-l-4 shadow-md"
                    style={{
                      backgroundColor: '#3b0a0a',
                      borderColor: '#ef4444',
                    }}
                  >
                    <div className="flex items-start gap-3 mb-3">
                      <AlertTriangle className="w-6 h-6 flex-shrink-0 mt-1 text-red-400" />
                      <h3 className="text-2xl font-bold text-red-400">
                        Quality and Reliability Concerns
                      </h3>
                    </div>
                    <p className="text-lg leading-relaxed ml-9 text-blue-100">
                      Clients avoid firms that lack standardized processes, as inconsistent methods lead to rework and quality issues.
                    </p>
                  </div>

                  {/* Quality Framework Section */}
                  <div
                    className="p-8 rounded-2xl border-2"
                    style={{
                      backgroundColor: '#003c52',
                      borderColor: '#00b8d9',
                    }}
                  >
                    <div className="flex items-center gap-4 mb-8">
                      <div
                        className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-xl"
                        style={{ backgroundColor: '#00b8d9' }}
                      >
                        <Award className="w-7 h-7 text-white" />
                      </div>
                      <h3 className="text-2xl font-bold text-white">
                        Our Quality Framework
                      </h3>
                    </div>

                    {/* AQMM Level 4 Card */}
                    <div
                      className="p-8 rounded-2xl shadow-lg transform hover:scale-105 transition-all duration-300"
                      style={{ backgroundColor: '#00485f' }}
                    >
                      <div className="flex items-start gap-5">
                        <div
                          className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
                          style={{ backgroundColor: '#00b8d9' }}
                        >
                          <CheckCircle className="w-6 h-6 text-white" />
                        </div>
                        <div>
                          <h4 className="text-xl font-bold mb-4 text-white">
                            AQMM Level  Standardisation
                          </h4>
                          <p className="text-lg leading-relaxed text-blue-100">
                            We adhere to the ICAI Audit Quality Maturity Model (AQMM) Level standards, ensuring systematic quality control, documented processes, and continuous improvement across all client engagements.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Trust Badge */}
                  <div
                    className="mt-8 p-6 rounded-2xl shadow-lg flex items-center gap-4"
                    style={{ backgroundColor: '#00b8d9' }}
                  >
                    <Shield className="w-8 h-8 text-white flex-shrink-0" />
                    <p className="text-lg font-bold text-white leading-relaxed">
                      Delivering consistent, reliable, and audit-ready results every time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* Services */}
        <section className="py-20"
          style={{ backgroundColor: '#c7ebf9' }}>
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold mb-6 text-00688e">
                Our Chartered Accountant Services
              </h2>
              <p className="text-xl max-w-4xl mx-auto leading-relaxed text-00688e">
                From corporate audits to startup advisory, our services are designed
                to help businesses thrive in today's competitive environment.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto mb-12">
              {[
                {
                  title: "Audit & Assurance",
                  link: "fdi/auditing-overview",
                  icon: <CheckCircle className="w-8 h-8" />,
                  items: [
                    "Statutory audits in accordance with legal requirements",
                    "Internal audits to improve internal controls and operational efficiency",
                    "Compliance audits to ensure adherence to applicable laws"
                  ]
                },
                {
                  title: "Taxation Services",
                  link: "fdi/business-taxation-overview",
                  icon: <TrendingUp className="w-8 h-8" />,
                  items: [
                    "GST registration, filing, and compliance management",
                    "Corporate and personal income tax planning and filing",
                    "Advisory on international taxation and transfer pricing"
                  ]
                },
                {
                  title: "Business Advisory",
                  link: "fdi/starting-business-in-india",
                  icon: <Users className="w-8 h-8" />,
                  items: [
                    "Assistance with business plans and financial modeling",
                    "Guidance for startups, including company incorporation and funding support",
                    "Private placement of equity shares, debentures, and venture capital advisory"
                  ]
                },
                {
                  title: "Corporate Compliance",
                  link: "fdi/statutory-requirement",
                  icon: <Award className="w-8 h-8" />,
                  items: [
                    "ROC filings, secretarial compliance, and corporate governance advisory",
                    "Assistance with mergers, acquisitions, and restructuring"
                  ]
                },
                {
                  title: "Transfer Pricing",
                  link: "/fdi/transfer-pricing-audit",
                  icon: <ArrowRight className="w-8 h-8" />,
                  items: [
                    "Preparation of Transfer Pricing documentation as per Indian Income Tax Rules",
                    "Benchmarking analysis to determine arm’s length pricing",
                  ]
                },
                {
                  title: "Company Formation in India",
                  link: "/fdi/company-formation-overview",
                  icon: <Users className="w-8 h-8" />,
                  items: [
                    "Advisory on choosing the right business structure (Private Limited, LLP, OPC, etc.)",
                    "Name approval and reservation with the Ministry of Corporate Affairs (MCA)",
                    "Drafting and filing of incorporation documents",
                  ]
                }
              ].map((service, index) => (
                <a
                  key={index}
                  href={service.link}
                  className="bg-white border-2 border-blue-200 rounded-xl p-8 hover:shadow-xl transition-all duration-300 group block"
                >
                  <div className="flex items-center gap-4 mb-6">
                    <div className="transition-colors duration-300" style={{ color: '#00688e' }}>
                      {service.icon}
                    </div>
                    <h3 className="text-xl font-bold transition-colors duration-300" style={{ color: '#00688e' }}>
                      {service.title}
                    </h3>
                  </div>

                  <ul className="space-y-3">
                    {service.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-start gap-3">
                        <div
                          className="w-2 h-2 rounded-full mt-2 flex-shrink-0 transition-colors duration-300"
                          style={{ backgroundColor: '#00688e' }}
                        ></div>
                        <span className="leading-relaxed transition-colors duration-300" style={{ color: '#00688e' }}>
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-6 pt-4 border-t border-blue-200 transition-colors duration-300">
                    <span className="font-medium transition-colors duration-300 flex items-center gap-2 text-sm" style={{ color: '#00688e' }}>
                      Learn More
                      <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </a>
              ))}
            </div>


          </div>
        </section>
        <section
          className="py-20 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #002b3a 0%, #00485f 50%, #00688e 100%)',
          }}
        >
          {/* Decorative background elements */}
          <div className="absolute inset-0 opacity-30">
            <div
              className="absolute top-10 left-10 w-80 h-80 rounded-full blur-3xl"
              style={{ backgroundColor: '#007b9e' }}
            ></div>
            <div
              className="absolute bottom-20 right-20 w-96 h-96 rounded-full blur-3xl"
              style={{ backgroundColor: '#0097b2' }}
            ></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-6xl mx-auto">
              {/* Header */}
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold mb-6 leading-tight text-white">
                  Offering Transparent, Value-Based Pricing Models
                </h2>
                <div
                  className="w-32 h-1.5 mx-auto rounded-full mb-4"
                  style={{ backgroundColor: '#00b8d9' }}
                ></div>
                <p className="text-xl font-semibold text-blue-100">
                  Redefining Pricing Through Value and Clarity
                </p>
              </div>

              {/* Main Card */}
              <div
                className="rounded-3xl p-10 md:p-12 shadow-2xl border-2 relative overflow-hidden group transition-all duration-500"
                style={{
                  backgroundColor: '#00384d',
                  borderColor: '#00b8d9',
                }}
              >
                {/* Decorative glow */}
                <div
                  className="absolute -bottom-10 -left-10 w-60 h-60 rounded-full blur-3xl group-hover:scale-125 transition-transform duration-700"
                  style={{ backgroundColor: '#005f75', opacity: 0.4 }}
                ></div>

                <div className="relative z-10">
                  {/* Pain Point Section */}
                  <div
                    className="mb-10 p-6 rounded-2xl border-l-4 shadow-md"
                    style={{
                      backgroundColor: '#3b0a0a',
                      borderColor: '#ef4444',
                    }}
                  >
                    <div className="flex items-start gap-3 mb-3">
                      <AlertTriangle className="w-6 h-6 flex-shrink-0 mt-1 text-red-400" />
                      <h3 className="text-2xl font-bold text-red-400">
                        Lack of Pricing Transparency
                      </h3>
                    </div>
                    <p className="text-lg leading-relaxed ml-9 text-blue-100">
                      Traditional fee models based on time tracking fail to differentiate between advisory value and compliance work.
                    </p>
                  </div>

                  {/* Pricing Philosophy Section */}
                  <div
                    className="p-8 rounded-2xl border-2"
                    style={{
                      backgroundColor: '#00485f',
                      borderColor: '#00b8d9',
                    }}
                  >
                    <div className="flex items-center gap-4 mb-8">
                      <div
                        className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-xl"
                        style={{ backgroundColor: '#00b8d9' }}
                      >
                        <Scale className="w-7 h-7 text-white" />
                      </div>
                      <h3 className="text-2xl font-bold text-white">
                        Our Pricing Philosophy
                      </h3>
                    </div>

                    {/* Two Key Cards */}
                    <div className="grid md:grid-cols-2 gap-8">
                      {/* Value-Based Pricing */}
                      <div
                        className="p-6 rounded-2xl shadow-lg transform hover:scale-105 transition-all duration-300"
                        style={{ backgroundColor: '#005f75' }}
                      >
                        <div className="flex items-start gap-4">
                          <div
                            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
                            style={{ backgroundColor: '#00b8d9' }}
                          >
                            <TrendingUp className="w-6 h-6 text-white" />
                          </div>
                          <div>
                            <h4 className="text-xl font-bold mb-3 text-white">
                              Value-Based Pricing
                            </h4>
                            <p className="text-blue-100 leading-relaxed">
                              Reflects the outcomes and efficiencies achieved through technology —
                              delivering up to <span className="font-semibold text-white">10x productivity gains.</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Clear Service Delineation */}
                      <div
                        className="p-6 rounded-2xl shadow-lg transform hover:scale-105 transition-all duration-300"
                        style={{ backgroundColor: '#005f75' }}
                      >
                        <div className="flex items-start gap-4">
                          <div
                            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
                            style={{ backgroundColor: '#00b8d9' }}
                          >
                            <Layers className="w-6 h-6 text-white" />
                          </div>
                          <div>
                            <h4 className="text-xl font-bold mb-3 text-white">
                              Clear Service Delineation
                            </h4>
                            <p className="text-blue-100 leading-relaxed">
                              We clearly distinguish high-value advisory services — such as
                              <span className="font-semibold text-white"> Digital Transformation </span>
                              and <span className="font-semibold text-white">Risk Advisory</span> —
                              from standard compliance tasks.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Closing Line */}
                    <div className="mt-8 text-center">
                      <p className="text-lg font-semibold text-blue-100">
                        This clarity ensures clients understand the value they receive
                        and the strategic benefits behind every engagement.
                      </p>
                    </div>
                  </div>

                  {/* Bottom Badge */}
                  <div
                    className="mt-8 p-6 rounded-2xl shadow-lg flex items-center gap-4 justify-center"
                    style={{ backgroundColor: '#00b8d9' }}
                  >
                    <Star className="w-8 h-8 text-white flex-shrink-0" />
                    <p className="text-lg font-bold text-white">
                      Transparent, Outcome-Driven, and Built on Trust.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>



        {/* Industries We Serve */}

        <section className="text-white py-20" style={{ backgroundColor: '#00688e' }}>
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl font-bold mb-8">Industries We Serve</h2>
              <div className="w-24 h-1 bg-white mx-auto rounded-full mb-8"></div>

              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                {[
                  "Manufacturing",
                  "IT & Software",
                  "Banking & Finance",
                  "Healthcare",
                  "Retail",
                  "Education",
                  "Real Estate",
                  "More Industries",
                  "Sports Management services",
                ].map((industry, index) => (
                  <div
                    key={index}
                    className="backdrop-blur-sm border border-blue-300/30 rounded-lg p-4 transition-all duration-300"
                    style={{ backgroundColor: 'rgba(204, 241, 255, 0.2)' }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'rgba(204, 241, 255, 0.3)')}
                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'rgba(204, 241, 255, 0.2)')}
                  >
                    <div className="flex items-center justify-center gap-2">
                      <CheckCircle className="w-5 h-5 text-green-400" />
                      {industry === "Sports Leagues" ? (
                        <Link to="/best-sports-ca-firm-india" className="text-white font-medium hover:underline">
                          {industry}
                        </Link>
                      ) : (
                        <span className="text-white font-medium">{industry}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <p className="text-xl text-blue-100 leading-relaxed">
                Our diverse client portfolio spans across industries like manufacturing, IT & software, banking and finance, healthcare, retail, education, and real estate. This multi-sector experience allows us to bring fresh perspectives and innovative solutions tailored to each industry's unique needs.
              </p>
            </div>
          </div>
        </section>



        {/* Our Team */}
        <section className="py-20 bg-[#c7ebf9]">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold mb-4" style={{ color: '#00688e' }}>Our Expert Team</h2>
              <div className="w-24 h-1 mx-auto rounded-full mb-6" style={{ backgroundColor: '#00688e' }}></div>
              <p className="text-xl max-w-3xl mx-auto" style={{ color: '#00688e' }}>
                Meet our experienced professionals who bring years of expertise in chartered accountancy,
                corporate law, and financial advisory services.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {ourTeam.map((member) => (
                <div key={member.id} className="bg-white border-2 border-blue-200 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 group" style={{ '&:hover': { borderColor: '#00688e' } }}>
                  {/* Profile Image */}
                  <div className="relative overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-90 object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ backgroundColor: 'rgba(0, 104, 142, 0.2)' }}></div>
                  </div>

                  {/* Card Content */}
                  <div className="p-8">
                    <div className="text-center mb-6">
                      <h3 className="text-2xl font-bold mb-2 group-hover:opacity-90 transition-colors duration-300" style={{ color: '#00688e' }}>
                        {member.name}
                      </h3>
                      <div className="inline-block text-white px-4 py-2 rounded-full text-sm font-semibold" style={{ backgroundColor: '#00688e' }}>
                        {member.position}
                      </div>
                    </div>

                    <p className="leading-relaxed text-center mb-6 group-hover:opacity-90 transition-colors duration-300" style={{ color: '#00688e' }}>
                      {member.description}
                    </p>

                    {/* Contact/Action Section */}
                    <div className="pt-4 border-t border-blue-200 group-hover:border-blue-300 transition-colors duration-300 text-center">
                      < Link to={URLs.ABOUT_US} className="font-medium transition-colors duration-300 flex items-center justify-center gap-2 mx-auto hover:opacity-80" style={{ color: '#00688e' }}>
                        View Profile
                        <ArrowRight className="w-4 h-4" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Clients */}
        <section className="text-white py-20" style={{ backgroundColor: '#00688e' }}>
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center mb-16">
              <h2 className="text-4xl font-bold mb-6">Our Clients</h2>
              <p className="text-xl text-blue-100 leading-relaxed">
                Our client list includes domestic and international entities of various sizes from different industries.
                Our team of experienced professionals provide financial solutions where client satisfaction is top priority.
                We are an accounting and auditing firm in India ensuring confidentiality and professional ethics.
                We have serviced clients from the following industries:
              </p>
            </div>

            <div className="max-w-7xl mx-auto grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              <Ticks>Foreign companies having subsidiary in India</Ticks>
              <Ticks>Foreign Companies having Branch / Liaison Offices in India</Ticks>
              <Ticks>Non-Resident Indians</Ticks>
              <Ticks>Automobiles and Auto Ancillaries</Ticks>
              <Ticks>Chemicals</Ticks>
              <Ticks>Consumer Durable</Ticks>
              <Ticks>Consultancy Support</Ticks>
              <Ticks>Education & Welfare</Ticks>
              <Ticks>Electronics</Ticks>
              <Ticks>Energy</Ticks>
              <Ticks>FMCG</Ticks>
              <Ticks>Food Processing</Ticks>
              <Ticks>Infrastructure</Ticks>
              <Ticks>Manufacturing</Ticks>
              <Ticks>Media</Ticks>
              <Ticks>Pharmaceuticals</Ticks>
              <Ticks>Real Estate & Construction</Ticks>
              <Ticks>Retailing & Distribution</Ticks>
              <Ticks>Software & Information Technology</Ticks>
              <Ticks>Telecommunications</Ticks>
              <Ticks>Trading</Ticks>
              <Ticks>Travel, Tourism & Leisure</Ticks>
              <Link to={URLs.SportsCAWebsite}>
                <Ticks>Sports Organization</Ticks>
              </Link>
            </div>
          </div>
        </section>

        <section className="text-white py-20" style={{ background: 'linear-gradient(to right, #00688e, #004a64, #00688e)' }}>
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto text-center">
              <h2 className="text-4xl font-bold mb-8">What Makes Us the Best CA Firm in India</h2>
              <div className="w-24 h-1 bg-white mx-auto rounded-full mb-12"></div>

              <div className="backdrop-blur-sm border border-blue-300/50 rounded-2xl p-10" style={{ backgroundColor: 'rgba(204, 241, 255, 0.1)' }}>
                <p className="text-xl text-blue-100 leading-relaxed mb-8">
                  While there are many CA firms in the country, our success lies in combining technical expertise with a deep understanding of business challenges. We do not just provide services — we partner with our clients to help them navigate financial complexities, identify growth opportunities, and stay compliant with ever-changing regulations.
                </p>

                <div className="grid md:grid-cols-3 gap-8 mb-8">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(59, 130, 246, 0.2)' }}>
                      <TrendingUp className="w-8 h-8 text-blue-300" />
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Proactive Approach</h3>
                    <p className="text-blue-200 text-sm">Anticipating problems before they arise</p>
                  </div>

                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(34, 197, 94, 0.2)' }}>
                      <Users className="w-8 h-8 text-green-300" />
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Client Partnership</h3>
                    <p className="text-blue-200 text-sm">True partners in your business journey</p>
                  </div>

                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(168, 85, 247, 0.2)' }}>
                      <Award className="w-8 h-8 text-purple-300" />
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Strategic Solutions</h3>
                    <p className="text-blue-200 text-sm">Keeping clients ahead of competition</p>
                  </div>
                </div>

                <p className="text-lg text-blue-200 leading-relaxed">
                  Our proactive approach ensures that we anticipate problems before they arise and create strategies that keep our clients ahead of the competition.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20" style={{ backgroundColor: '#ccf1ff' }}>
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold mb-4" style={{ color: '#00688e' }}>
                What Our Clients Say
              </h2>
              <div className="w-24 h-1 mx-auto rounded-full" style={{ backgroundColor: '#00688e' }}></div>
            </div>
            <Testimonials />
          </div>
        </section>

        {/* Call to Action */}
        <section
          className="text-white py-20"
          style={{
            background: "linear-gradient(to right, #00688e, #004a64)",
          }}
        >
          <div className="container mx-auto px-4">
            <h2 className="text-4xl font-bold mb-6 text-center">
              Partner with the <span className="text-blue-200">Best CA Firm in India</span>
            </h2>

            <p className="text-lg text-blue-100 max-w-full mx-auto mb-10 leading-relaxed text-left">
              Whether you are a <span className="font-semibold text-white"> startup  </span>
               seeking financial guidance, a <span className="font-semibold text-white">growing business </span>
                  in need of structured audits, or an
              <span className="font-semibold text-white">  established company </span>
              looking for expert tax planning, <strong>SARASH JAIN & ASSOCIATES</strong> is your trusted partner.
              We combine <span className="text-blue-200">knowledge </span>,
              <span className="text-blue-200"> experience</span>, and a
              <span className="text-blue-200"> client-focused mindset </span>
              to deliver results that truly make a difference.
            </p>


            <p className="text-lg text-blue-100 max-w-full mx-auto mb-12 leading-relaxed text-left">
              Contact us today to schedule a consultation and discover why countless businesses and individuals
              consider us the <span className="font-semibold text-white">best CA firm in India</span>.
              With SARASH JAIN & ASSOCIATES by your side, you can focus on
              <span className="text-blue-200"> growing your business</span> while we take care of your
              <span className="text-blue-200"> financial success</span>.
            </p>

            <div className="flex flex-wrap justify-center gap-6 mb-10">
              <div className="flex items-center gap-2 text-blue-200">
                <Phone className="w-5 h-5" />
                <span>+91-8684893331</span>
              </div>
              <div className="flex items-center gap-2 text-blue-200">
                <Mail className="w-5 h-5" />
                <span>sjasonipat@gmail.com</span>
              </div>
              <div className="flex items-center gap-2 text-blue-200 max-w-md text-left">
                <MapPin className="w-5 h-5 flex-shrink-0" />
                <div>
                  <p>
                  884/23, Near Mission Chowk, Rohtak Road, Sonepat-131001, Haryana
                  </p>
                  <p className="pt-2">
                    Branch office: E-52, Aastha Kunj, Sector-18
                    Rohini-110089, Delhi, India
                  </p>
                </div>
              </div>

            </div>

            <Link
              to={URLs.QUERIES}
              className="px-8 py-4 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 flex items-center gap-2 mx-auto"
              style={{ backgroundColor: "#ccf1ff", color: "#00688e" }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#b3e7ff")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#ccf1ff")}
            >
              Get in Touch Today
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;